import { DropDownModel } from "../../../app/core/models/dropdown-model";

export class LanguageConstant {
    static GetAllAsDataItem(): Array<DropDownModel> {
        return [
            { value: 'en', display: 'EN' },
            { value: 'zh-cn', display: '简' },
            { value: 'zh-hk', display: '繁' },
          ];
    }
}